import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@heroui/react';

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-blue-600">404</h1>
        <h2 className="text-4xl font-semibold text-gray-800 mt-4">Page Not Found</h2>
        <p className="text-gray-600 mt-4 mb-8">
          Sorry, the page you're looking for doesn't exist.
        </p>
        <Link to="/">
          <Button color="primary" size="lg">
            Go Home
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
